// Ladakh - TypeScript Application Entry Point
console.log("Ladakh application loaded with TypeScript!");

// Example TypeScript interface
interface AppConfig {
  name: string;
  version: string;
}

const config: AppConfig = {
  name: "Ladakh",
  version: "1.0.0"
};

document.addEventListener("DOMContentLoaded", () => {
  console.log(`Welcome to ${config.name} v${config.version}`);
});
